import { render, staticRenderFns } from "./ExportFields.vue?vue&type=template&id=16885478&scoped=true"
import script from "./ExportFields.vue?vue&type=script&lang=js"
export * from "./ExportFields.vue?vue&type=script&lang=js"
import style0 from "./ExportFields.vue?vue&type=style&index=0&id=16885478&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16885478",
  null
  
)

export default component.exports